import styles from './Arrow.module.css';

export default function AnimatedArrow() {
  return (
    <>
      {/* Desktop version */}
      <div className={styles.arrowContainer}>
        <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect width="48" height="48" rx="18" fill="#1E1C1C"/>
          <path 
            className={styles.arrowPath}
            d="M16.1757 20.8417C16.6313 20.3861 17.37 20.3861 17.8256 20.8417L24.0007 27.0168L30.1757 20.8417C30.6313 20.3861 31.37 20.3861 31.8256 20.8417C32.2812 21.2973 32.2812 22.036 31.8256 22.4916L24.8256 29.4916C24.37 29.9472 23.6313 29.9472 23.1757 29.4916L16.1757 22.4916C15.7201 22.036 15.7201 21.2973 16.1757 20.8417Z" 
            fill="#FAFAFA"
          />
        </svg>
      </div>

      {/* Mobile version */}
      <div className={styles.arrowContainerMobile}>
        <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect width="32" height="32" rx="12" fill="#FAFAFA"/>
          <path 
            className={styles.arrowPath}
            d="M10.0377 13.5938C10.3848 13.2467 10.9476 13.2467 11.2948 13.5938L15.9996 18.2986L20.7044 13.5938C21.0515 13.2467 21.6143 13.2467 21.9614 13.5938C22.3086 13.941 22.3086 14.5038 21.9614 14.8509L16.6281 20.1843C16.281 20.5314 15.7182 20.5314 15.371 20.1843L10.0377 14.8509C9.69056 14.5038 9.69056 13.941 10.0377 13.5938Z" 
            fill="#1E1C1C"
          />
        </svg>
      </div>
    </>
  );
}